import _ from "lodash";
import { type Dispatch, type SetStateAction, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import InputLabel from "../input/Input.react";
import type { DropdownSearchParams } from "./index.react";

export type DropdownSearchWidgetProps = {
  search: DropdownSearchParams | boolean;
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
} & React.ComponentPropsWithoutRef<"div">;

export const DropdownSearchWidget = forwardRef<HTMLInputElement, DropdownSearchWidgetProps>(
  ({ search, searchValue, setSearchValue = () => {}, ...props }, ref) => {
    const { t } = useTranslation(["pass"]);

    return (
      <div
        className="flex items-center pb-2"
        {..._.omit(props, "search", "searchValue", "setSearchValue")}
      >
        <InputLabel
          ref={ref}
          borderless
          placeholder={
            search
              ? typeof search !== "boolean"
                ? search?.placeholder
                : t("flow.input.search_placeholder")
              : t("flow.input.search_placeholder")
          }
          value={searchValue}
          onChange={(e) => setSearchValue(e)}
          onFocus={(e) => e.stopPropagation()}
          onBlur={(e) => e.stopPropagation()}
          data-cy="dropdown-search-input"
        />
      </div>
    );
  }
);
